export const openLightboxWithKeys = (e: React.KeyboardEvent, callback: () => void): void => {
	if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
		e.preventDefault(); // Prevent the default action
		e.stopPropagation(); // Stop the event from bubbling up
		callback(); // Execute the callback function
	}
};
